/* tslint:disable */
/* eslint-disable */
/**
 * City Challenge API
 * The official API for all City Challenge services.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccessToken
 */
export interface AccessToken {
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    id: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof AccessToken
     */
    user: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    userAgent: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    ip: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    lastUsed: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    invalidated: string;
    /**
     * 
     * @type {number}
     * @memberof AccessToken
     */
    ttl: number;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    scope: string;
    /**
     * 
     * @type {string}
     * @memberof AccessToken
     */
    provider: string;
}
/**
 * 
 * @export
 * @interface AnonymousAccessDto
 */
export interface AnonymousAccessDto {
    /**
     * 
     * @type {string}
     * @memberof AnonymousAccessDto
     */
    deviceToken: string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousAccessDto
     */
    secret: string;
}
/**
 * 
 * @export
 * @interface AppleTokenDto
 */
export interface AppleTokenDto {
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    authorizationCode: string;
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof AppleTokenDto
     */
    bundleId: string;
}
/**
 * 
 * @export
 * @interface ArchiveInfo
 */
export interface ArchiveInfo {
    /**
     * 
     * @type {number}
     * @memberof ArchiveInfo
     */
    totalSize: number;
    /**
     * 
     * @type {number}
     * @memberof ArchiveInfo
     */
    compressedSize: number;
    /**
     * 
     * @type {Array<ArchivedFile>}
     * @memberof ArchiveInfo
     */
    files?: Array<ArchivedFile>;
}
/**
 * 
 * @export
 * @interface ArchivedFile
 */
export interface ArchivedFile {
    /**
     * 
     * @type {string}
     * @memberof ArchivedFile
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ArchivedFile
     */
    fileKey: string;
    /**
     * 
     * @type {number}
     * @memberof ArchivedFile
     */
    fileSize: number;
}
/**
 * 
 * @export
 * @interface ArticleAnalyticsDto
 */
export interface ArticleAnalyticsDto {
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsDto
     */
    divisionId: string;
}
/**
 * 
 * @export
 * @interface ArticleAnalyticsEntity
 */
export interface ArticleAnalyticsEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsEntity
     */
    id: string;
    /**
     * 
     * @type {ArticleEntity}
     * @memberof ArticleAnalyticsEntity
     */
    article?: ArticleEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof ArticleAnalyticsEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ArticleAnalyticsEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof ArticleAnalyticsEntity
     */
    userKey: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleAnalyticsEntity
     */
    created: number;
}
/**
 * 
 * @export
 * @interface ArticleEntity
 */
export interface ArticleEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleEntity
     */
    isPublished: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof ArticleEntity
     */
    body: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    published?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleEntity
     */
    video?: string;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof ArticleEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ArticleGroupEntity>}
     * @memberof ArticleEntity
     */
    groups?: Array<ArticleGroupEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof ArticleEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof ArticleEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof ArticleEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<ArticleTranslationEntity>}
     * @memberof ArticleEntity
     */
    translations?: Array<ArticleTranslationEntity>;
}
/**
 * 
 * @export
 * @interface ArticleGroupDivisionEntity
 */
export interface ArticleGroupDivisionEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupDivisionEntity
     */
    hideUntil?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ArticleGroupDivisionEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {ArticleGroupEntity}
     * @memberof ArticleGroupDivisionEntity
     */
    articleGroup: ArticleGroupEntity;
}
/**
 * 
 * @export
 * @interface ArticleGroupEntity
 */
export interface ArticleGroupEntity {
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleGroupEntity
     */
    name: string;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof ArticleGroupEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<string>}
     * @memberof ArticleGroupEntity
     */
    articles?: Array<string>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof ArticleGroupEntity
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
}
/**
 * 
 * @export
 * @interface ArticleTranslationEntity
 */
export interface ArticleTranslationEntity {
    /**
     * 
     * @type {ArticleEntity}
     * @memberof ArticleTranslationEntity
     */
    article?: ArticleEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof ArticleTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    video?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof ArticleTranslationEntity
     */
    body?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface AssetEntity
 */
export interface AssetEntity {
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    ref?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    src: string;
    /**
     * 
     * @type {number}
     * @memberof AssetEntity
     */
    size: number;
    /**
     * 
     * @type {AssetMetadataDto}
     * @memberof AssetEntity
     */
    metadata?: AssetMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    extension: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    mimetype: string;
    /**
     * 
     * @type {{ [key: string]: AssetJobDto; }}
     * @memberof AssetEntity
     */
    jobs?: { [key: string]: AssetJobDto; };
    /**
     * 
     * @type {DivisionEntity}
     * @memberof AssetEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetEntity
     */
    updated?: string;
    /**
     * 
     * @type {AssetOriginType}
     * @memberof AssetEntity
     */
    origin: AssetOriginType;
    /**
     * 
     * @type {UserEntity}
     * @memberof AssetEntity
     */
    user?: UserEntity;
}
/**
 * 
 * @export
 * @interface AssetJobDto
 */
export interface AssetJobDto {
    /**
     * 
     * @type {string}
     * @memberof AssetJobDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetJobDto
     */
    status: AssetJobDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AssetJobDto
     */
    progress?: number;
    /**
     * 
     * @type {object}
     * @memberof AssetJobDto
     */
    result?: object;
    /**
     * 
     * @type {number}
     * @memberof AssetJobDto
     */
    updated?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AssetJobDtoStatusEnum {
    Done = 'done',
    Error = 'error',
    Pending = 'pending',
    Suspended = 'suspended'
}

/**
 * 
 * @export
 * @interface AssetMetadaAttributionDto
 */
export interface AssetMetadaAttributionDto {
    /**
     * 
     * @type {string}
     * @memberof AssetMetadaAttributionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadaAttributionDto
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface AssetMetadataDto
 */
export interface AssetMetadataDto {
    /**
     * 
     * @type {AssetMetadataResolutionDto}
     * @memberof AssetMetadataDto
     */
    resolution?: AssetMetadataResolutionDto;
    /**
     * 
     * @type {AssetMetadaAttributionDto}
     * @memberof AssetMetadataDto
     */
    attribution?: AssetMetadaAttributionDto;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadataDto
     */
    blurhash?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadataDto
     */
    alt?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetMetadataDto
     */
    transcript?: string;
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataDto
     */
    duration?: number;
    /**
     * 
     * @type {AssetMetadataResolutionDto}
     * @memberof AssetMetadataDto
     */
    focusPoint?: AssetMetadataResolutionDto;
}
/**
 * 
 * @export
 * @interface AssetMetadataResolutionDto
 */
export interface AssetMetadataResolutionDto {
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataResolutionDto
     */
    width: number;
    /**
     * 
     * @type {number}
     * @memberof AssetMetadataResolutionDto
     */
    height: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AssetOriginType {
    Upload = 'upload',
    Unsplash = 'unsplash',
    Pexels = 'pexels',
    Giphy = 'giphy',
    Generated = 'generated'
}

/**
 * 
 * @export
 * @interface CityEntity
 */
export interface CityEntity {
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CityEntity
     */
    updated?: string;
    /**
     * 
     * @type {CountryEntity}
     * @memberof CityEntity
     */
    country?: CountryEntity;
    /**
     * 
     * @type {boolean}
     * @memberof CityEntity
     */
    published?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof CityEntity
     */
    coordinates?: GeoPointDto;
}
/**
 * 
 * @export
 * @interface CompanyEntity
 */
export interface CompanyEntity {
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    name: string;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof CompanyEntity
     */
    type: CompanyTypeEnum;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof CompanyEntity
     */
    whitelabel: WhitelabelEntity;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof CompanyEntity
     */
    divisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    crmId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    demioApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    demioApiSecret?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    webinarGeekApiKey?: string;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof CompanyEntity
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof CompanyEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ArticleGroupEntity>}
     * @memberof CompanyEntity
     */
    articleGroups?: Array<ArticleGroupEntity>;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyEntity
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyEntity
     */
    disableTracking?: boolean;
    /**
     * 
     * @type {ResolvedSubscriptionDto}
     * @memberof CompanyEntity
     */
    subscriptionInfo: ResolvedSubscriptionDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum CompanyTypeEnum {
    Company = 'company',
    Country = 'country'
}

/**
 * 
 * @export
 * @interface CountryEntity
 */
export interface CountryEntity {
    /**
     * 
     * @type {string}
     * @memberof CountryEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CountryEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CountryEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CountryEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<CityEntity>}
     * @memberof CountryEntity
     */
    cities?: Array<CityEntity>;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof CountryEntity
     */
    whitelabel?: WhitelabelEntity;
}
/**
 * 
 * @export
 * @interface CouponEntity
 */
export interface CouponEntity {
    /**
     * 
     * @type {string}
     * @memberof CouponEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CouponEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponEntity
     */
    redeemed?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CouponEntity
     */
    handedOut?: boolean;
    /**
     * 
     * @type {GameEntity}
     * @memberof CouponEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {PaymentEntity}
     * @memberof CouponEntity
     */
    payment?: PaymentEntity;
    /**
     * 
     * @type {PurchaseEntity}
     * @memberof CouponEntity
     */
    purchase?: PurchaseEntity;
}
/**
 * 
 * @export
 * @interface DeepLinkFindDto
 */
export interface DeepLinkFindDto {
    /**
     * 
     * @type {number}
     * @memberof DeepLinkFindDto
     */
    screenWidth: number;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkFindDto
     */
    screenHeight: number;
}
/**
 * 
 * @export
 * @interface DeepLinkPutDto
 */
export interface DeepLinkPutDto {
    /**
     * 
     * @type {string}
     * @memberof DeepLinkPutDto
     */
    domain: string;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkPutDto
     */
    screenWidth: number;
    /**
     * 
     * @type {number}
     * @memberof DeepLinkPutDto
     */
    screenHeight: number;
    /**
     * 
     * @type {string}
     * @memberof DeepLinkPutDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface DeepLinkResponseDto
 */
export interface DeepLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DeepLinkResponseDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface DiscountCodeEntity
 */
export interface DiscountCodeEntity {
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeEntity
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountCodeEntity
     */
    discount: number;
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeEntity
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscountCodeEntity
     */
    untill?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscountCodeEntity
     */
    maxUses?: number;
    /**
     * 
     * @type {Array<PaymentEntity>}
     * @memberof DiscountCodeEntity
     */
    payments?: Array<PaymentEntity>;
}
/**
 * 
 * @export
 * @interface DivisionBehaviour
 */
export interface DivisionBehaviour {
    /**
     * 
     * @type {boolean}
     * @memberof DivisionBehaviour
     */
    watermark: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionBehaviour
     */
    expires?: string;
}
/**
 * 
 * @export
 * @interface DivisionContactDto
 */
export interface DivisionContactDto {
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    email?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionContactDto
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionContactDto
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface DivisionDepartmentEntity
 */
export interface DivisionDepartmentEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    name: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionDepartmentEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionDepartmentEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface DivisionEntity
 */
export interface DivisionEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    updated?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    published?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof DivisionEntity
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {DivisionTypeEnum}
     * @memberof DivisionEntity
     */
    type: DivisionTypeEnum;
    /**
     * 
     * @type {DivisionPlatformTypeEnum}
     * @memberof DivisionEntity
     */
    platformType?: DivisionPlatformTypeEnum;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof DivisionEntity
     */
    company?: CompanyEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    code?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DivisionEntity
     */
    domains?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    forceAuthentication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    enableOnboarding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    requiresValidQR?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    projectWideLeaderboard?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    articlesEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    eventsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    disableEventCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    disableStoryOverview?: boolean;
    /**
     * Always hide map, even if this division has multiple location-based games.
     * @type {boolean}
     * @memberof DivisionEntity
     */
    alwaysHideMap?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBasedDisableGps?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    mapBasedShowLegend?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    customMapUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    favicon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    pwaIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    backgroundImage?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof DivisionEntity
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof DivisionEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<AssetEntity>}
     * @memberof DivisionEntity
     */
    assets?: Array<AssetEntity>;
    /**
     * 
     * @type {EnergyPointsEntity}
     * @memberof DivisionEntity
     */
    energyPoints?: EnergyPointsEntity;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    invertEnergyPoints?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DivisionEntity
     */
    addEnergyPointsOnSignup?: number;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof DivisionEntity
     */
    users?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<DomainEntity>}
     * @memberof DivisionEntity
     */
    customDomains?: Array<DomainEntity>;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionEntity
     */
    contact?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionEntity
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    contactPageImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionEntity
     */
    hasContact?: boolean;
    /**
     * 
     * @type {Array<PasswordlessTokenEntity>}
     * @memberof DivisionEntity
     */
    passwordlessTokens?: Array<PasswordlessTokenEntity>;
    /**
     * 
     * @type {Array<ArticleGroupDivisionEntity>}
     * @memberof DivisionEntity
     */
    articleGroupDivisions?: Array<ArticleGroupDivisionEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof DivisionEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionEntity
     */
    baseLanguage?: LanguageEntity;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof DivisionEntity
     */
    translations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionSubscriptionEntity>}
     * @memberof DivisionEntity
     */
    subscriptions?: Array<DivisionSubscriptionEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof DivisionEntity
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {EmailServiceTypeEnum}
     * @memberof DivisionEntity
     */
    emailService?: EmailServiceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    emailServiceIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorBackground?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    colorText?: string;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionEntity
     */
    fontPrimary?: FontDefinitionDto;
    /**
     * 
     * @type {FontDefinitionDto}
     * @memberof DivisionEntity
     */
    fontSecondary?: FontDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionEntity
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {PrivacyModeEnum}
     * @memberof DivisionEntity
     */
    privacyMode?: PrivacyModeEnum;
    /**
     * 
     * @type {DivisionBehaviour}
     * @memberof DivisionEntity
     */
    behaviour?: DivisionBehaviour;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    gtmTagId?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionEntity
     */
    legalEmail?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DivisionPlatformTypeEnum {
    Default = 'default',
    Web = 'web',
    Mobile = 'mobile'
}

/**
 * 
 * @export
 * @interface DivisionSubscriptionEntity
 */
export interface DivisionSubscriptionEntity {
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    id: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionSubscriptionEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof DivisionSubscriptionEntity
     */
    pricePerYear: number;
    /**
     * 
     * @type {number}
     * @memberof DivisionSubscriptionEntity
     */
    maxPublishedGames: number;
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    fromDate: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionSubscriptionEntity
     */
    toDate?: string;
}
/**
 * 
 * @export
 * @interface DivisionTranslationEntity
 */
export interface DivisionTranslationEntity {
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionTranslationEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof DivisionTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionTranslationEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    privacyDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {DocumentDefinitionDto}
     * @memberof DivisionTranslationEntity
     */
    tosDocument?: DocumentDefinitionDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    contactButtonTitle?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DivisionTranslationEntity
     */
    contactPageText?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    contactPageImage?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    experiencesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    experiencesWelcomeText?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    articlesTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    eventsTabTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    mapBasedTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DivisionTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DivisionTypeEnum {
    Division = 'division',
    City = 'city'
}

/**
 * 
 * @export
 * @interface DivisionUserEntity
 */
export interface DivisionUserEntity {
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DivisionUserEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof DivisionUserEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {DivisionDepartmentEntity}
     * @memberof DivisionUserEntity
     */
    department?: DivisionDepartmentEntity;
    /**
     * 
     * @type {string}
     * @memberof DivisionUserEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof DivisionUserEntity
     */
    lastLogin: string;
}
/**
 * 
 * @export
 * @interface DocumentDefinitionDto
 */
export interface DocumentDefinitionDto {
    /**
     * 
     * @type {DocumentTypeEnum}
     * @memberof DocumentDefinitionDto
     */
    type: DocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefinitionDto
     */
    upload?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDefinitionDto
     */
    url?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof DocumentDefinitionDto
     */
    markdown?: MarkdownTextDto;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DocumentTypeEnum {
    None = 'none',
    Link = 'link',
    Upload = 'upload',
    Markdown = 'markdown',
    Pregenerated = 'pregenerated'
}

/**
 * 
 * @export
 * @interface DomainEntity
 */
export interface DomainEntity {
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    domain: string;
    /**
     * 
     * @type {DomainTypeEnum}
     * @memberof DomainEntity
     */
    type: DomainTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainEntity
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof DomainEntity
     */
    division: DivisionEntity;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DomainTypeEnum {
    Subdomain = 'subdomain',
    Custom = 'custom'
}

/**
 * 
 * @export
 * @interface DownloadDto
 */
export interface DownloadDto {
    /**
     * 
     * @type {string}
     * @memberof DownloadDto
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadDto
     */
    appVersion: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadDto
     */
    releaseVersion?: number;
}
/**
 * 
 * @export
 * @interface DownloadUrlDto
 */
export interface DownloadUrlDto {
    /**
     * 
     * @type {string}
     * @memberof DownloadUrlDto
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadUrlDto
     */
    bundlePath?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum EmailServiceTypeEnum {
    Mailchimp = 'mailchimp',
    Brevo = 'brevo'
}

/**
 * 
 * @export
 * @interface EnergyPointsEntity
 */
export interface EnergyPointsEntity {
    /**
     * 
     * @type {string}
     * @memberof EnergyPointsEntity
     */
    id: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof EnergyPointsEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EnergyPointsEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof EnergyPointsEntity
     */
    energypoints: number;
    /**
     * 
     * @type {string}
     * @memberof EnergyPointsEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EnergyPointsEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EnergyPointsEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface EnergyPointsResponseDto
 */
export interface EnergyPointsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EnergyPointsResponseDto
     */
    energyPoints: number;
}
/**
 * 
 * @export
 * @interface EstimatedLocationDto
 */
export interface EstimatedLocationDto {
    /**
     * 
     * @type {number}
     * @memberof EstimatedLocationDto
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof EstimatedLocationDto
     */
    lon: number;
}
/**
 * 
 * @export
 * @interface EventConnectionDto
 */
export interface EventConnectionDto {
    /**
     * 
     * @type {EventConnectionFromDto}
     * @memberof EventConnectionDto
     */
    from: EventConnectionFromDto;
    /**
     * 
     * @type {EventConnectionToDto}
     * @memberof EventConnectionDto
     */
    to: EventConnectionToDto;
    /**
     * 
     * @type {boolean}
     * @memberof EventConnectionDto
     */
    completed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionDto
     */
    id?: string;
}
/**
 * 
 * @export
 * @interface EventConnectionFromDto
 */
export interface EventConnectionFromDto {
    /**
     * 
     * @type {string}
     * @memberof EventConnectionFromDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionFromDto
     */
    prop: string;
}
/**
 * 
 * @export
 * @interface EventConnectionToDto
 */
export interface EventConnectionToDto {
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    prop: string;
    /**
     * 
     * @type {string}
     * @memberof EventConnectionToDto
     */
    transform?: string;
}
/**
 * 
 * @export
 * @interface EventEntity
 */
export interface EventEntity {
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventEntity
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    hideUntil?: string;
    /**
     * 
     * @type {number}
     * @memberof EventEntity
     */
    energyPoints?: number;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof EventEntity
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof EventEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof EventEntity
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof EventEntity
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    processedDemioOn?: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntity
     */
    processedWebinarGeekOn?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof EventEntity
     */
    participants?: Array<EventParticipantEntity>;
    /**
     * 
     * @type {EventEntity}
     * @memberof EventEntity
     */
    copyFrom?: EventEntity;
}
/**
 * 
 * @export
 * @interface EventParticipantEntity
 */
export interface EventParticipantEntity {
    /**
     * 
     * @type {EventEntity}
     * @memberof EventParticipantEntity
     */
    event: EventEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventParticipantEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    confirmed?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    created: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventParticipantEntity
     */
    noShow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    reminderSent?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    demioJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    webinarGeekJoinUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof EventParticipantEntity
     */
    webinarGeekSubscriptionId?: string;
}
/**
 * 
 * @export
 * @interface EventUpdateDto
 */
export interface EventUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    demioEventId?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    webinarGeekBroadcastId?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof EventUpdateDto
     */
    description?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    emailNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    hideUntil?: string;
    /**
     * 
     * @type {number}
     * @memberof EventUpdateDto
     */
    energyPoints?: number;
    /**
     * This URL field will replace the button \'I want to join!\' when the field has content. The button will redirect the user to the URL.
     * @type {string}
     * @memberof EventUpdateDto
     */
    link?: string;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof EventUpdateDto
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    image?: string;
    /**
     * If zero, this will mean unlimited participants
     * @type {number}
     * @memberof EventUpdateDto
     */
    maxParticipants?: number;
    /**
     * Whether hiding participants list or not, default is false
     * @type {boolean}
     * @memberof EventUpdateDto
     */
    hideParticipants?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    updated?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof EventUpdateDto
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    processedDemioOn?: string;
    /**
     * 
     * @type {string}
     * @memberof EventUpdateDto
     */
    processedWebinarGeekOn?: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof EventUpdateDto
     */
    user?: UserEntity;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof EventUpdateDto
     */
    participants?: Array<EventParticipantEntity>;
    /**
     * 
     * @type {EventEntity}
     * @memberof EventUpdateDto
     */
    copyFrom?: EventEntity;
}
/**
 * 
 * @export
 * @interface FacebookTokenDto
 */
export interface FacebookTokenDto {
    /**
     * 
     * @type {string}
     * @memberof FacebookTokenDto
     */
    accessToken: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FacebookTokenDto
     */
    permissions: Array<string>;
}
/**
 * 
 * @export
 * @interface FeatureSetDto
 */
export interface FeatureSetDto {
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    events?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    articles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    auth?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    branding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureSetDto
     */
    advancedLogic?: boolean;
}
/**
 * 
 * @export
 * @interface FeedbackEntity
 */
export interface FeedbackEntity {
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackEntity
     */
    content: string;
    /**
     * 
     * @type {SceneEntity}
     * @memberof FeedbackEntity
     */
    scene?: SceneEntity;
    /**
     * 
     * @type {SessionEntity}
     * @memberof FeedbackEntity
     */
    session?: SessionEntity;
}
/**
 * 
 * @export
 * @interface FeedbackPostDto
 */
export interface FeedbackPostDto {
    /**
     * 
     * @type {string}
     * @memberof FeedbackPostDto
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackPostDto
     */
    sessionId?: string;
}
/**
 * 
 * @export
 * @interface FileUploadDto
 */
export interface FileUploadDto {
    /**
     * 
     * @type {any}
     * @memberof FileUploadDto
     */
    file: any;
}
/**
 * 
 * @export
 * @interface FileUploadResultDto
 */
export interface FileUploadResultDto {
    /**
     * 
     * @type {string}
     * @memberof FileUploadResultDto
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadResultDto
     */
    fileKey: string;
}
/**
 * 
 * @export
 * @interface FontDefinitionDto
 */
export interface FontDefinitionDto {
    /**
     * 
     * @type {FontTypeEnum}
     * @memberof FontDefinitionDto
     */
    type: FontTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FontDefinitionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FontDefinitionDto
     */
    googleUrl?: string;
    /**
     * 
     * @type {any}
     * @memberof FontDefinitionDto
     */
    customFont?: any;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum FontTypeEnum {
    Default = 'default',
    Google = 'google',
    Custom = 'custom',
    Primary = 'primary'
}

/**
 * 
 * @export
 * @interface GameData
 */
export interface GameData {
    /**
     * 
     * @type {string}
     * @memberof GameData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameData
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof GameData
     */
    baseScenario: object;
    /**
     * 
     * @type {object}
     * @memberof GameData
     */
    release: object;
}
/**
 * 
 * @export
 * @interface GameEntity
 */
export interface GameEntity {
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    gameType: GameEntityGameTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    image?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GameEntity
     */
    slideshowImages?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    defaultColorTheme?: string;
    /**
     * When a game is hidden, it does not show up on game overview, but as an unlockable item.
     * @type {boolean}
     * @memberof GameEntity
     */
    hidden?: boolean;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof GameEntity
     */
    coordinates?: GeoPointDto;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    distanceInMeters?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    batteryNeeded?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    timeInMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    address?: string;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    energyPoints?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    hideLeaderboard?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    hideReviews?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    publishToCMS?: boolean;
    /**
     * 
     * @type {ThemeEntity}
     * @memberof GameEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    linkingForceRedirect?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<ScenarioEntity>}
     * @memberof GameEntity
     */
    scenarios?: Array<ScenarioEntity>;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof GameEntity
     */
    baseScenario?: ScenarioEntity;
    /**
     * 
     * @type {Array<GameLanguageEntity>}
     * @memberof GameEntity
     */
    gameLanguages?: Array<GameLanguageEntity>;
    /**
     * 
     * @type {Array<GameVariableEntity>}
     * @memberof GameEntity
     */
    variables?: Array<GameVariableEntity>;
    /**
     * 
     * @type {Array<GameWebhookEntity>}
     * @memberof GameEntity
     */
    webhooks?: Array<GameWebhookEntity>;
    /**
     * 
     * @type {GameReleaseEntity}
     * @memberof GameEntity
     */
    release?: GameReleaseEntity;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    releaseCount?: number;
    /**
     * 
     * @type {GameReleaseStatus}
     * @memberof GameEntity
     */
    releaseStatus?: GameReleaseStatus;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    lastEdit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GameEntity
     */
    published?: boolean;
    /**
     * 
     * @type {CityEntity}
     * @memberof GameEntity
     */
    city?: CityEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof GameEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {Array<SessionEntity>}
     * @memberof GameEntity
     */
    sessions?: Array<SessionEntity>;
    /**
     * 
     * @type {Array<PurchaseEntity>}
     * @memberof GameEntity
     */
    purchases?: Array<PurchaseEntity>;
    /**
     * 
     * @type {Array<LineItemEntity>}
     * @memberof GameEntity
     */
    lineItems?: Array<LineItemEntity>;
    /**
     * 
     * @type {Array<CouponEntity>}
     * @memberof GameEntity
     */
    coupons?: Array<CouponEntity>;
    /**
     * 
     * @type {Array<QRCodeEntity>}
     * @memberof GameEntity
     */
    qrCodes?: Array<QRCodeEntity>;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    reviewCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    playedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof GameEntity
     */
    reviewRating?: number;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof GameEntity
     */
    defaultLanguage?: LanguageEntity;
    /**
     * If set to true, the generated QR code will cause the app start a game session after scanning it.
     * @type {boolean}
     * @memberof GameEntity
     */
    startSessionImmediately?: boolean;
    /**
     * 
     * @type {UserEntity}
     * @memberof GameEntity
     */
    creator?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    hideUntil?: string;
    /**
     * If set to true, this experience will not automatically add UTM parameters to each outbound URL.
     * @type {boolean}
     * @memberof GameEntity
     */
    disableOutboundUtm?: boolean;
    /**
     * If set to false, content animations will not be enabled for this experience.
     * @type {boolean}
     * @memberof GameEntity
     */
    enableContentAnimations?: boolean;
    /**
     * If set to false, this story will not show the icon overlay on top of the experience
     * @type {boolean}
     * @memberof GameEntity
     */
    enableIconOverlay?: boolean;
    /**
     * Enable tap to skip for this game, this will disable sliding motions.
     * @type {boolean}
     * @memberof GameEntity
     */
    enableTapToSkip?: boolean;
    /**
     * Enable to maximize accessibility features for this story.
     * @type {boolean}
     * @memberof GameEntity
     */
    maximizeAccessibility?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    storyIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameEntity
     */
    shareDescription?: string;
    /**
     * Templates that use this story as a base to build on.
     * @type {Array<TemplateEntity>}
     * @memberof GameEntity
     */
    templates?: Array<TemplateEntity>;
}

/**
    * @export
    * @enum {string}
    */
export enum GameEntityGameTypeEnum {
    Story = 'story',
    Trivia = 'trivia',
    Minigame = 'minigame'
}

/**
 * 
 * @export
 * @interface GameLanguageEntity
 */
export interface GameLanguageEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof GameLanguageEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof GameLanguageEntity
     */
    language: LanguageEntity;
    /**
     * 
     * @type {boolean}
     * @memberof GameLanguageEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GameLanguageEntity
     */
    image?: string;
}
/**
 * 
 * @export
 * @interface GameReleaseEntity
 */
export interface GameReleaseEntity {
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseEntity
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    created?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof GameReleaseEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    downloadUrl: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    bundlePath: string;
    /**
     * 
     * @type {ArchiveInfo}
     * @memberof GameReleaseEntity
     */
    archiveInfo?: ArchiveInfo;
    /**
     * 
     * @type {GameData}
     * @memberof GameReleaseEntity
     */
    gameData?: GameData;
    /**
     * 
     * @type {Array<MapInfo>}
     * @memberof GameReleaseEntity
     */
    maps?: Array<MapInfo>;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    releaseStatus?: GameReleaseEntityReleaseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    warningMessage?: string;
    /**
     * Which version of the mobile API the release was built against
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionBuilt?: string;
    /**
     * Up to which mobile API version the auto checks have passed for this release
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionAutoChecked?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseEntity
     */
    mapSize?: number;
    /**
     * 
     * @type {Array<ReleaseLanguageDto>}
     * @memberof GameReleaseEntity
     */
    languages?: Array<ReleaseLanguageDto>;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseEntity
     */
    appVersionVerified?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsAr: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsVr: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsGps: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsMagneto: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    containsCamera: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GameReleaseEntity
     */
    supportsDynamicDownloads: boolean;
    /**
     * 
     * @type {UserEntity}
     * @memberof GameReleaseEntity
     */
    user?: UserEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum GameReleaseEntityReleaseStatusEnum {
    Pending = 'pending',
    Published = 'published',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface GameReleaseStatus
 */
export interface GameReleaseStatus {
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseStatus
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    releaseStatus?: GameReleaseStatusReleaseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof GameReleaseStatus
     */
    warningMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof GameReleaseStatus
     */
    progress?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum GameReleaseStatusReleaseStatusEnum {
    Pending = 'pending',
    Published = 'published',
    Error = 'error'
}

/**
 * 
 * @export
 * @interface GameVariableEntity
 */
export interface GameVariableEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof GameVariableEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof GameVariableEntity
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GameVariableEntity
     */
    weight?: number;
    /**
     * 
     * @type {GameVariableTypeEnum}
     * @memberof GameVariableEntity
     */
    type: GameVariableTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof GameVariableEntity
     */
    defaultValue?: object;
    /**
     * 
     * @type {string}
     * @memberof GameVariableEntity
     */
    created?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GameVariableTypeEnum {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean'
}

/**
 * 
 * @export
 * @interface GameWebhookEntity
 */
export interface GameWebhookEntity {
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    url?: string;
    /**
     * 
     * @type {GameWebhookTypeEnum}
     * @memberof GameWebhookEntity
     */
    type: GameWebhookTypeEnum;
    /**
     * 
     * @type {GameWebhookTriggerTypeEnum}
     * @memberof GameWebhookEntity
     */
    trigger: GameWebhookTriggerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    email?: string;
    /**
     * 
     * @type {object}
     * @memberof GameWebhookEntity
     */
    config?: object;
    /**
     * 
     * @type {object}
     * @memberof GameWebhookEntity
     */
    extras?: object;
    /**
     * 
     * @type {object}
     * @memberof GameWebhookEntity
     */
    headers?: object;
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof GameWebhookEntity
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof GameWebhookEntity
     */
    game: GameEntity;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum GameWebhookTriggerTypeEnum {
    VariableUpdate = 'variable_update'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum GameWebhookTypeEnum {
    Url = 'url',
    Email = 'email'
}

/**
 * 
 * @export
 * @interface GeoPointDto
 */
export interface GeoPointDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof GeoPointDto
     */
    coordinates: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof GeoPointDto
     */
    type: string;
}
/**
 * 
 * @export
 * @interface GoogleTokenDto
 */
export interface GoogleTokenDto {
    /**
     * 
     * @type {string}
     * @memberof GoogleTokenDto
     */
    idToken: string;
}
/**
 * 
 * @export
 * @interface HighscoreDto
 */
export interface HighscoreDto {
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof HighscoreDto
     */
    score: number;
    /**
     * 
     * @type {number}
     * @memberof HighscoreDto
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof HighscoreDto
     */
    finished: string;
}
/**
 * 
 * @export
 * @interface HotlinkDeployEventDto
 */
export interface HotlinkDeployEventDto {
    /**
     * 
     * @type {number}
     * @memberof HotlinkDeployEventDto
     */
    timestamp: number;
    /**
     * 
     * @type {object}
     * @memberof HotlinkDeployEventDto
     */
    payload: object;
}
/**
 * 
 * @export
 * @interface LanguageEntity
 */
export interface LanguageEntity {
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<TranslationEntity>}
     * @memberof LanguageEntity
     */
    translations?: Array<TranslationEntity>;
    /**
     * 
     * @type {Array<GameLanguageEntity>}
     * @memberof LanguageEntity
     */
    gameLanguages?: Array<GameLanguageEntity>;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof LanguageEntity
     */
    games?: Array<GameEntity>;
    /**
     * 
     * @type {Array<ArticleTranslationEntity>}
     * @memberof LanguageEntity
     */
    articleTranslations?: Array<ArticleTranslationEntity>;
    /**
     * 
     * @type {Array<DivisionTranslationEntity>}
     * @memberof LanguageEntity
     */
    divisionTranslations?: Array<DivisionTranslationEntity>;
    /**
     * 
     * @type {Array<TagTranslationEntity>}
     * @memberof LanguageEntity
     */
    tagTranslations?: Array<TagTranslationEntity>;
    /**
     * 
     * @type {Array<ThemeTranslationEntity>}
     * @memberof LanguageEntity
     */
    themeTranslations?: Array<ThemeTranslationEntity>;
    /**
     * 
     * @type {Array<ArticleEntity>}
     * @memberof LanguageEntity
     */
    articles?: Array<ArticleEntity>;
    /**
     * 
     * @type {Array<TagEntity>}
     * @memberof LanguageEntity
     */
    tags?: Array<TagEntity>;
    /**
     * 
     * @type {Array<ThemeEntity>}
     * @memberof LanguageEntity
     */
    themes?: Array<ThemeEntity>;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof LanguageEntity
     */
    divisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {Array<PageContentEntity>}
     * @memberof LanguageEntity
     */
    pageContent?: Array<PageContentEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof LanguageEntity
     */
    enabled?: boolean;
}
/**
 * 
 * @export
 * @interface LanguageTranslationsDto
 */
export interface LanguageTranslationsDto {
    /**
     * 
     * @type {string}
     * @memberof LanguageTranslationsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LanguageTranslationsDto
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LanguageTranslationsDto
     */
    translations?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof LanguageTranslationsDto
     */
    enabled: boolean;
}
/**
 * 
 * @export
 * @interface LayoutNodeDto
 */
export interface LayoutNodeDto {
    /**
     * 
     * @type {string}
     * @memberof LayoutNodeDto
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof LayoutNodeDto
     */
    props: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof LayoutNodeDto
     */
    displayName?: string;
    /**
     * 
     * @type {Array<LayoutNodeDto>}
     * @memberof LayoutNodeDto
     */
    children: Array<LayoutNodeDto>;
}
/**
 * 
 * @export
 * @interface LineItemEntity
 */
export interface LineItemEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof LineItemEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {PaymentEntity}
     * @memberof LineItemEntity
     */
    payment: PaymentEntity;
    /**
     * 
     * @type {string}
     * @memberof LineItemEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof LineItemEntity
     */
    updated?: string;
    /**
     * 
     * @type {number}
     * @memberof LineItemEntity
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof LineItemEntity
     */
    total: number;
}
/**
 * 
 * @export
 * @interface MapInfo
 */
export interface MapInfo {
    /**
     * 
     * @type {string}
     * @memberof MapInfo
     */
    id: string;
    /**
     * 
     * @type {MapInfoBounds}
     * @memberof MapInfo
     */
    bounds: MapInfoBounds;
    /**
     * 
     * @type {string}
     * @memberof MapInfo
     */
    styleURL: string;
    /**
     * 
     * @type {number}
     * @memberof MapInfo
     */
    zoom: number;
}
/**
 * 
 * @export
 * @interface MapInfoBounds
 */
export interface MapInfoBounds {
    /**
     * 
     * @type {MapInfoLocation}
     * @memberof MapInfoBounds
     */
    sw: MapInfoLocation;
    /**
     * 
     * @type {MapInfoLocation}
     * @memberof MapInfoBounds
     */
    ne: MapInfoLocation;
}
/**
 * 
 * @export
 * @interface MapInfoLocation
 */
export interface MapInfoLocation {
    /**
     * 
     * @type {number}
     * @memberof MapInfoLocation
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof MapInfoLocation
     */
    lng: number;
}
/**
 * 
 * @export
 * @interface MarkdownTextDto
 */
export interface MarkdownTextDto {
    /**
     * 
     * @type {string}
     * @memberof MarkdownTextDto
     */
    text?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MarkdownTextDto
     */
    files?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface PageContentEntity
 */
export interface PageContentEntity {
    /**
     * 
     * @type {PageEntity}
     * @memberof PageContentEntity
     */
    page?: PageEntity;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof PageContentEntity
     */
    whitelabel?: WhitelabelEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof PageContentEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof PageContentEntity
     */
    content: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof PageContentEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PageContentEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface PageEntity
 */
export interface PageEntity {
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PageEntity
     */
    name: string;
    /**
     * 
     * @type {Array<PageContentEntity>}
     * @memberof PageEntity
     */
    pageContent?: Array<PageContentEntity>;
}
/**
 * 
 * @export
 * @interface PasswordlessRequestDto
 */
export interface PasswordlessRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    divisionId?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestDto
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface PasswordlessRequestResultDto
 */
export interface PasswordlessRequestResultDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessRequestResultDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface PasswordlessTokenEntity
 */
export interface PasswordlessTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessTokenEntity
     */
    token: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof PasswordlessTokenEntity
     */
    user: UserEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof PasswordlessTokenEntity
     */
    division: DivisionEntity;
    /**
     * 
     * @type {number}
     * @memberof PasswordlessTokenEntity
     */
    tries: number;
}
/**
 * 
 * @export
 * @interface PasswordlessVerifyDto
 */
export interface PasswordlessVerifyDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordlessVerifyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordlessVerifyDto
     */
    token: string;
}
/**
 * 
 * @export
 * @interface PasswordlessVerifyResultDto
 */
export interface PasswordlessVerifyResultDto {
    /**
     * 
     * @type {ReturnedAccessToken}
     * @memberof PasswordlessVerifyResultDto
     */
    accessToken: ReturnedAccessToken;
    /**
     * 
     * @type {boolean}
     * @memberof PasswordlessVerifyResultDto
     */
    setupCompleted: boolean;
    /**
     * 
     * @type {Array<DivisionDepartmentEntity>}
     * @memberof PasswordlessVerifyResultDto
     */
    departments?: Array<DivisionDepartmentEntity>;
}
/**
 * 
 * @export
 * @interface PaymentEntity
 */
export interface PaymentEntity {
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    reference?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    codesCreated?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    mailSent?: string;
    /**
     * 
     * @type {Array<LineItemEntity>}
     * @memberof PaymentEntity
     */
    lineItems: Array<LineItemEntity>;
    /**
     * 
     * @type {Array<CouponEntity>}
     * @memberof PaymentEntity
     */
    coupons: Array<CouponEntity>;
    /**
     * 
     * @type {DiscountCodeEntity}
     * @memberof PaymentEntity
     */
    discountCode: DiscountCodeEntity;
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    subtotal?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentEntity
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    status: PaymentEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    vendor: PaymentEntityVendorEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    returnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEntity
     */
    refunded?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PaymentEntityStatusEnum {
    Open = 'open',
    Canceled = 'canceled',
    Pending = 'pending',
    Authorized = 'authorized',
    Expired = 'expired',
    Failed = 'failed',
    Paid = 'paid'
}
/**
    * @export
    * @enum {string}
    */
export enum PaymentEntityVendorEnum {
    Firstparty = 'firstparty',
    Getyourguide = 'getyourguide',
    Bokun = 'bokun'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PrivacyModeEnum {
    Loose = 'loose',
    Strict = 'strict'
}

/**
 * 
 * @export
 * @interface PurchaseEntity
 */
export interface PurchaseEntity {
    /**
     * 
     * @type {GameEntity}
     * @memberof PurchaseEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {GameEntity}
     * @memberof PurchaseEntity
     */
    user: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof PurchaseEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseEntity
     */
    updated?: string;
    /**
     * 
     * @type {WhitelabelTypeEnum}
     * @memberof PurchaseEntity
     */
    platform: WhitelabelTypeEnum;
    /**
     * 
     * @type {CouponEntity}
     * @memberof PurchaseEntity
     */
    coupon: CouponEntity;
}
/**
 * 
 * @export
 * @interface QRCodeEntity
 */
export interface QRCodeEntity {
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    type: QRCodeEntityTypeEnum;
    /**
     * 
     * @type {QRCodeShareTypeEnum}
     * @memberof QRCodeEntity
     */
    shareType?: QRCodeShareTypeEnum;
    /**
     * 
     * @type {GeoPointDto}
     * @memberof QRCodeEntity
     */
    coordinates?: GeoPointDto;
    /**
     * If supplied, the QR code will redirect to this URL instead of the game.
     * @type {string}
     * @memberof QRCodeEntity
     */
    customUrl?: string;
    /**
     * If set to true, the game will automatically start.
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    autoStart?: boolean;
    /**
     * If set to true, the game will always start from the start.
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    alwaysRestart?: boolean;
    /**
     * 
     * @type {object}
     * @memberof QRCodeEntity
     */
    variables?: object;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    validFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    validUntil?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof QRCodeEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    language?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof QRCodeEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    style: QRCodeEntityStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    background?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    logo?: string;
    /**
     * 
     * @type {number}
     * @memberof QRCodeEntity
     */
    logoBorder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QRCodeEntity
     */
    logoBackgroundRemoved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareImage?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeEntity
     */
    shareDescription?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum QRCodeEntityTypeEnum {
    Mobile = 'mobile',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum QRCodeEntityStyleEnum {
    Default = 'default',
    Square = 'square',
    Dotted = 'dotted'
}

/**
 * 
 * @export
 * @interface QRCodeHitEntity
 */
export interface QRCodeHitEntity {
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    device?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    os?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    osVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    browser?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    browserVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof QRCodeHitEntity
     */
    ipHash?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum QRCodeShareTypeEnum {
    Legacy = 'legacy',
    ShareLink = 'shareLink',
    ShareQr = 'shareQr',
    ShareCanva = 'shareCanva',
    EmbedPopup = 'embedPopup',
    EmbedInline = 'embedInline',
    EmbedCustom = 'embedCustom',
    Social = 'social',
    SharePreview = 'sharePreview'
}

/**
 * 
 * @export
 * @interface QrDto
 */
export interface QrDto {
    /**
     * 
     * @type {string}
     * @memberof QrDto
     */
    png: string;
    /**
     * 
     * @type {string}
     * @memberof QrDto
     */
    text: string;
}
/**
 * 
 * @export
 * @interface QrRedirectDto
 */
export interface QrRedirectDto {
    /**
     * 
     * @type {string}
     * @memberof QrRedirectDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface RedeemCouponRequestDto
 */
export interface RedeemCouponRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RedeemCouponRequestDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface ReleaseLanguageDto
 */
export interface ReleaseLanguageDto {
    /**
     * 
     * @type {string}
     * @memberof ReleaseLanguageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseLanguageDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ResolvedSubscriptionDto
 */
export interface ResolvedSubscriptionDto {
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    projectLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    gameLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    sceneLimit: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSubscriptionDto
     */
    sessionLimit: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvedSubscriptionDto
     */
    watermark: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResolvedSubscriptionDto
     */
    excludedElements: Array<string>;
    /**
     * 
     * @type {FeatureSetDto}
     * @memberof ResolvedSubscriptionDto
     */
    featureSet: FeatureSetDto;
    /**
     * 
     * @type {boolean}
     * @memberof ResolvedSubscriptionDto
     */
    trial: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResolvedSubscriptionDto
     */
    expires?: string;
}
/**
 * 
 * @export
 * @interface ResultDto
 */
export interface ResultDto {
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    result: string;
}
/**
 * 
 * @export
 * @interface ReturnedAccessToken
 */
export interface ReturnedAccessToken {
    /**
     * 
     * @type {string}
     * @memberof ReturnedAccessToken
     */
    id: string;
    /**
     * 
     * @type {UserEntity}
     * @memberof ReturnedAccessToken
     */
    user: UserEntity;
}
/**
 * 
 * @export
 * @interface ReviewDto
 */
export interface ReviewDto {
    /**
     * 
     * @type {string}
     * @memberof ReviewDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewDto
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewDto
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof ReviewDto
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface ReviewEntity
 */
export interface ReviewEntity {
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEntity
     */
    content?: string;
    /**
     * Default is true
     * @type {boolean}
     * @memberof ReviewEntity
     */
    approved: boolean;
    /**
     * Default is 5.0
     * @type {number}
     * @memberof ReviewEntity
     */
    rating: number;
    /**
     * 
     * @type {SessionEntity}
     * @memberof ReviewEntity
     */
    session?: SessionEntity;
}
/**
 * 
 * @export
 * @interface ReviewPostDto
 */
export interface ReviewPostDto {
    /**
     * 
     * @type {string}
     * @memberof ReviewPostDto
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof ReviewPostDto
     */
    rating: number;
}
/**
 * 
 * @export
 * @interface ScenarioEntity
 */
export interface ScenarioEntity {
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    mode: ScenarioEntityModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    jumpTarget?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ScenarioEntity
     */
    updated?: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof ScenarioEntity
     */
    game: GameEntity;
    /**
     * 
     * @type {Array<ScenarioSceneEntity>}
     * @memberof ScenarioEntity
     */
    scenes?: Array<ScenarioSceneEntity>;
    /**
     * If this scenario is part of a scene it is a branch of that scene.
     * @type {SceneEntity}
     * @memberof ScenarioEntity
     */
    scene?: SceneEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum ScenarioEntityModeEnum {
    Default = 'default',
    Loopback = 'loopback',
    Jump = 'jump'
}

/**
 * 
 * @export
 * @interface ScenarioSceneEntity
 */
export interface ScenarioSceneEntity {
    /**
     * 
     * @type {number}
     * @memberof ScenarioSceneEntity
     */
    weight?: number;
    /**
     * 
     * @type {SceneEntity}
     * @memberof ScenarioSceneEntity
     */
    scene: SceneEntity;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof ScenarioSceneEntity
     */
    scenario: ScenarioEntity;
}
/**
 * 
 * @export
 * @interface SceneAggregationDto
 */
export interface SceneAggregationDto {
    /**
     * 
     * @type {string}
     * @memberof SceneAggregationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SceneAggregationDto
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof SceneAggregationDto
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneAggregationDto
     */
    max?: number;
    /**
     * Should be one of: enum, open, number
     * @type {string}
     * @memberof SceneAggregationDto
     */
    type: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SceneAggregationDto
     */
    enumValues?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SceneAggregationDto
     */
    enumLabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface SceneEntity
 */
export interface SceneEntity {
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<LayoutNodeDto>}
     * @memberof SceneEntity
     */
    layout?: Array<LayoutNodeDto>;
    /**
     * 
     * @type {Array<SceneAggregationDto>}
     * @memberof SceneEntity
     */
    aggregation?: Array<SceneAggregationDto>;
    /**
     * 
     * @type {object}
     * @memberof SceneEntity
     */
    variableActions?: object;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    lockedUntil?: string;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    maxPoints?: number;
    /**
     * 
     * @type {number}
     * @memberof SceneEntity
     */
    bonusWithinSeconds?: number;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof SceneEntity
     */
    explanationText?: MarkdownTextDto | null;
    /**
     * 
     * @type {string}
     * @memberof SceneEntity
     */
    buttonText?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SceneEntity
     */
    translations?: { [key: string]: any; };
    /**
     * 
     * @type {Array<EventConnectionDto>}
     * @memberof SceneEntity
     */
    connections?: Array<EventConnectionDto>;
    /**
     * 
     * @type {ScenarioSceneEntity}
     * @memberof SceneEntity
     */
    scenarios?: ScenarioSceneEntity;
    /**
     * 
     * @type {ScenarioEntity}
     * @memberof SceneEntity
     */
    scenario?: ScenarioEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SceneEntity
     */
    statistics?: StatisticEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SceneEntity
     */
    statisticEvents?: StatisticEntity;
    /**
     * Scenarios that are branches of the scene are contained in this field.
     * @type {Array<ScenarioEntity>}
     * @memberof SceneEntity
     */
    branches?: Array<ScenarioEntity>;
    /**
     * 
     * @type {Array<any>}
     * @memberof SceneEntity
     */
    assets?: Array<any>;
}
/**
 * 
 * @export
 * @interface SessionEntity
 */
export interface SessionEntity {
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    userKey?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    playerName?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    updated: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    updatedSessionOn: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    processedStatsOn: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    score?: number;
    /**
     * Default null
     * @type {string}
     * @memberof SessionEntity
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    finished?: string;
    /**
     * Default 100, must be between 0 to 100
     * @type {number}
     * @memberof SessionEntity
     */
    batteryStarted: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    batteryFinished?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    completion: number;
    /**
     * 
     * @type {object}
     * @memberof SessionEntity
     */
    gameData?: object;
    /**
     * 
     * @type {GameEntity}
     * @memberof SessionEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {ReviewEntity}
     * @memberof SessionEntity
     */
    review?: ReviewEntity;
    /**
     * 
     * @type {UserEntity}
     * @memberof SessionEntity
     */
    user?: UserEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    platform: SessionEntityPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    appVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    buildNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    bundleId?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    activeSceneIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionEntity
     */
    numScenes?: number;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SessionEntity
     */
    statistics?: StatisticEntity;
    /**
     * 
     * @type {StatisticEntity}
     * @memberof SessionEntity
     */
    statisticEvents?: StatisticEntity;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    lastProcessedScene?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    activeSceneId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionEntity
     */
    source?: SessionEntitySourceEnum;
    /**
     * ID of the inbound story if it was redirected.
     * @type {string}
     * @memberof SessionEntity
     */
    sourceStoryId?: string;
    /**
     * Variables that were entered during the session
     * @type {{ [key: string]: string; }}
     * @memberof SessionEntity
     */
    variables?: { [key: string]: string; };
}

/**
    * @export
    * @enum {string}
    */
export enum SessionEntityPlatformEnum {
    Ios = 'ios',
    Android = 'android',
    Web = 'web'
}
/**
    * @export
    * @enum {string}
    */
export enum SessionEntitySourceEnum {
    Builder = 'builder',
    Story = 'story',
    Restart = 'restart'
}

/**
 * 
 * @export
 * @interface SessionSourceDto
 */
export interface SessionSourceDto {
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionSourceDto
     */
    storyId?: string;
}
/**
 * 
 * @export
 * @interface SessionUpdateDto
 */
export interface SessionUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    userKey: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    gameId: string;
    /**
     * 
     * @type {object}
     * @memberof SessionUpdateDto
     */
    gameData?: object;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    playerName?: string;
    /**
     * 
     * @type {ReviewPostDto}
     * @memberof SessionUpdateDto
     */
    review?: ReviewPostDto;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    started?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    finished?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    score?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    completion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    platform: SessionUpdateDtoPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    systemVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    appVersion?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    releaseVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    buildNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionUpdateDto
     */
    bundleId?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    activeSceneIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    numScenes?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    batteryStarted?: number;
    /**
     * 
     * @type {number}
     * @memberof SessionUpdateDto
     */
    batteryFinished?: number;
    /**
     * QR Code hit id for the session.
     * @type {QRCodeHitEntity}
     * @memberof SessionUpdateDto
     */
    qrCodeHit?: QRCodeHitEntity;
    /**
     * Source for the session
     * @type {SessionSourceDto}
     * @memberof SessionUpdateDto
     */
    source?: SessionSourceDto;
    /**
     * Variables that were entered during the session
     * @type {{ [key: string]: any; }}
     * @memberof SessionUpdateDto
     */
    variables?: { [key: string]: any; };
}

/**
    * @export
    * @enum {string}
    */
export enum SessionUpdateDtoPlatformEnum {
    Ios = 'ios',
    Android = 'android',
    Web = 'web'
}

/**
 * 
 * @export
 * @interface SimpleOkResponse
 */
export interface SimpleOkResponse {
    /**
     * 
     * @type {string}
     * @memberof SimpleOkResponse
     */
    result: string;
}
/**
 * 
 * @export
 * @interface StatisticEntity
 */
export interface StatisticEntity {
    /**
     * 
     * @type {SessionEntity}
     * @memberof StatisticEntity
     */
    session: SessionEntity;
    /**
     * 
     * @type {SceneEntity}
     * @memberof StatisticEntity
     */
    scene: SceneEntity;
    /**
     * 
     * @type {string}
     * @memberof StatisticEntity
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof StatisticEntity
     */
    numberValue: number;
    /**
     * 
     * @type {string}
     * @memberof StatisticEntity
     */
    stringValue?: string;
    /**
     * 
     * @type {number}
     * @memberof StatisticEntity
     */
    index: number;
}
/**
 * 
 * @export
 * @interface TagEntity
 */
export interface TagEntity {
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TagEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TagEntity
     */
    articles?: Array<string>;
    /**
     * 
     * @type {CompanyEntity}
     * @memberof TagEntity
     */
    company: CompanyEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof TagEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<TagTranslationEntity>}
     * @memberof TagEntity
     */
    translations?: Array<TagTranslationEntity>;
}
/**
 * 
 * @export
 * @interface TagTranslationEntity
 */
export interface TagTranslationEntity {
    /**
     * 
     * @type {TagEntity}
     * @memberof TagTranslationEntity
     */
    tag?: TagEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof TagTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof TagTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TagTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TemplateCategoryEntity
 */
export interface TemplateCategoryEntity {
    /**
     * 
     * @type {string}
     * @memberof TemplateCategoryEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateCategoryEntity
     */
    name: string;
    /**
     * 
     * @type {Array<TemplateEntity>}
     * @memberof TemplateCategoryEntity
     */
    templates?: Array<TemplateEntity>;
}
/**
 * 
 * @export
 * @interface TemplateEntity
 */
export interface TemplateEntity {
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof TemplateEntity
     */
    description: string;
    /**
     * 
     * @type {GameEntity}
     * @memberof TemplateEntity
     */
    game?: GameEntity;
    /**
     * 
     * @type {TemplateCategoryEntity}
     * @memberof TemplateEntity
     */
    category?: TemplateCategoryEntity;
}
/**
 * 
 * @export
 * @interface ThemeEntity
 */
export interface ThemeEntity {
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeEntity
     */
    updated?: string;
    /**
     * 
     * @type {WhitelabelEntity}
     * @memberof ThemeEntity
     */
    whitelabel?: WhitelabelEntity;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof ThemeEntity
     */
    division?: DivisionEntity;
    /**
     * 
     * @type {Array<LanguageEntity>}
     * @memberof ThemeEntity
     */
    baseLanguage?: Array<LanguageEntity>;
    /**
     * 
     * @type {Array<ThemeTranslationEntity>}
     * @memberof ThemeEntity
     */
    translations?: Array<ThemeTranslationEntity>;
}
/**
 * 
 * @export
 * @interface ThemeTranslationEntity
 */
export interface ThemeTranslationEntity {
    /**
     * 
     * @type {ThemeEntity}
     * @memberof ThemeTranslationEntity
     */
    theme?: ThemeEntity;
    /**
     * 
     * @type {LanguageEntity}
     * @memberof ThemeTranslationEntity
     */
    language?: LanguageEntity;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThemeTranslationEntity
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ThemeTranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TranslationEntity
 */
export interface TranslationEntity {
    /**
     * 
     * @type {LanguageEntity}
     * @memberof TranslationEntity
     */
    language: LanguageEntity;
    /**
     * 
     * @type {TranslationTokenEntity}
     * @memberof TranslationEntity
     */
    translationToken: TranslationTokenEntity;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface TranslationTokenEntity
 */
export interface TranslationTokenEntity {
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    key: string;
    /**
     * 
     * @type {Array<TranslationEntity>}
     * @memberof TranslationTokenEntity
     */
    translations: Array<TranslationEntity>;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    firstUsedVersion: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    lastUsedVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    group: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslationTokenEntity
     */
    updated?: string;
}
/**
 * 
 * @export
 * @interface UserCompleteSetupDto
 */
export interface UserCompleteSetupDto {
    /**
     * 
     * @type {string}
     * @memberof UserCompleteSetupDto
     */
    departmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCompleteSetupDto
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserCompleteSetupDto
     */
    anonymous?: boolean;
}
/**
 * 
 * @export
 * @interface UserEditDto
 */
export interface UserEditDto {
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEditDto
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEditDto
     */
    anonymous?: boolean;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserEditDto
     */
    bio?: MarkdownTextDto;
}
/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    nickname?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    anonymous?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    image?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    mfaPhone?: string;
    /**
     * 
     * @type {MarkdownTextDto}
     * @memberof UserEntity
     */
    bio?: MarkdownTextDto;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    acceptLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    activationPending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserEntity
     */
    superAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    appleUserId?: string;
    /**
     * 
     * @type {Array<DivisionUserEntity>}
     * @memberof UserEntity
     */
    divisions?: Array<DivisionUserEntity>;
    /**
     * 
     * @type {Array<ArticleAnalyticsEntity>}
     * @memberof UserEntity
     */
    articleAnalytics?: Array<ArticleAnalyticsEntity>;
    /**
     * 
     * @type {Array<EventEntity>}
     * @memberof UserEntity
     */
    events?: Array<EventEntity>;
    /**
     * 
     * @type {Array<DivisionEntity>}
     * @memberof UserEntity
     */
    contactForDivisions?: Array<DivisionEntity>;
    /**
     * 
     * @type {Array<GameEntity>}
     * @memberof UserEntity
     */
    creatorOfCityGame?: Array<GameEntity>;
    /**
     * 
     * @type {number}
     * @memberof UserEntity
     */
    countedEnergyPoints?: number;
    /**
     * 
     * @type {Array<EventParticipantEntity>}
     * @memberof UserEntity
     */
    participations?: Array<EventParticipantEntity>;
    /**
     * Note: role is no longer a column on the entity, and is calculated by counting the AccessControl rules.When the user has more than one access control rule, he is considered a builder. Should only be used in the mobile app to decide wether or not to show developer options. 
     * @type {string}
     * @memberof UserEntity
     * @deprecated
     */
    role: UserEntityRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    twoFactorMethod?: UserEntityTwoFactorMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEntity
     */
    nextAnalyticsMail?: string;
    /**
     * 
     * @type {DivisionEntity}
     * @memberof UserEntity
     */
    activeDivision?: DivisionEntity;
}

/**
    * @export
    * @enum {string}
    */
export enum UserEntityRoleEnum {
    Client = 'client',
    Builder = 'builder'
}
/**
    * @export
    * @enum {string}
    */
export enum UserEntityTwoFactorMethodEnum {
    Sms = 'sms'
}

/**
 * 
 * @export
 * @interface WhitelabelEntity
 */
export interface WhitelabelEntity {
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    bundleId: string;
    /**
     * 
     * @type {WhitelabelTypeEnum}
     * @memberof WhitelabelEntity
     */
    type: WhitelabelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    updated?: string;
    /**
     * 
     * @type {Array<ThemeEntity>}
     * @memberof WhitelabelEntity
     */
    themes?: Array<ThemeEntity>;
    /**
     * 
     * @type {Array<PageContentEntity>}
     * @memberof WhitelabelEntity
     */
    pageContent?: Array<PageContentEntity>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhitelabelEntity
     */
    excludedElements?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    webDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    rootDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    linkingDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    authDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    senderName?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    senderEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    passwordlessMailTemplate?: string;
    /**
     * The Brevo template of the confirmation e-mail that is sent when someone signs up for an event
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventConfirmation?: string;
    /**
     * The Brevo template of the reminder e-mail that is sent for events. (1 day in advance)
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventReminder?: string;
    /**
     * The Brevo template of the confirmation e-mail that is sent when someone signs up for an event, and they have been placed on the waiting list.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventConfirmationSpot?: string;
    /**
     * The ID of the Brevo template that is sent when an event spot becomes available. A null value means that no mail will be sent for this Whitelabel
     * @type {string}
     * @memberof WhitelabelEntity
     */
    eventSpotTemplate?: string;
    /**
     * The ID of the Brevo template that is sent when a new account is invited. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    invitedNewAccountTemplate?: string;
    /**
     * The ID of the Brevo template that is sent when a new account is invited. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    invitedExistingAccountTemplate?: string;
    /**
     * The server for the Mailchimp API connection. If you define the Mailchimp settings, starting a new session will result in the user being added to Mailchimp list
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpServer?: string;
    /**
     * The API key needed to connect to the Mailchimp API.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpApiKey?: string;
    /**
     * Wether this whitelabel forces authentication throughout all platform.
     * @type {boolean}
     * @memberof WhitelabelEntity
     */
    forceAuthentication?: boolean;
    /**
     * Wether billing is enabled on this whitelabel.
     * @type {boolean}
     * @memberof WhitelabelEntity
     */
    billingEnabled?: boolean;
    /**
     * The ID of the Mailchimp subscriber list where users get added to. Whenever a user starts a game, the game id will be added as a tag on that subscription.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    mailchimpList?: string;
    /**
     * The API key needed to connect to the Mailchimp API.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    brevoApiKey?: string;
    /**
     * The Brevo contact list that users get added to when signing up.
     * @type {string}
     * @memberof WhitelabelEntity
     */
    brevoList?: string;
    /**
     * The recipient mail address of various notification mails, such as feedback and reviews. 
     * @type {string}
     * @memberof WhitelabelEntity
     */
    notificationRecipient?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum WhitelabelTypeEnum {
    Geographic = 'geographic',
    Business = 'business',
    Learning = 'learning'
}


/**
 * ClientPrivateApi - axios parameter creator
 * @export
 */
export const ClientPrivateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all valid purchases of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPurchases: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/allPurchases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authStatus: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateEvent: async (divisionId: string, eventUpdateDto: EventUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling clientCreateEvent.');
            }
            // verify required parameter 'eventUpdateDto' is not null or undefined
            if (eventUpdateDto === null || eventUpdateDto === undefined) {
                throw new RequiredError('eventUpdateDto','Required parameter eventUpdateDto was null or undefined when calling clientCreateEvent.');
            }
            const localVarPath = `/client/division/{divisionId}/event`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventUpdateDto !== undefined ? eventUpdateDto : {}) : (eventUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientParticipateEvent: async (eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientParticipateEvent.');
            }
            const localVarPath = `/client/event/{eventId}/participate`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUnparticipateEvent: async (eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientUnparticipateEvent.');
            }
            const localVarPath = `/client/event/{eventId}/unparticipate`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateEvent: async (eventId: string, eventUpdateDto: EventUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling clientUpdateEvent.');
            }
            // verify required parameter 'eventUpdateDto' is not null or undefined
            if (eventUpdateDto === null || eventUpdateDto === undefined) {
                throw new RequiredError('eventUpdateDto','Required parameter eventUpdateDto was null or undefined when calling clientUpdateEvent.');
            }
            const localVarPath = `/client/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof eventUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(eventUpdateDto !== undefined ? eventUpdateDto : {}) : (eventUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSetup: async (userCompleteSetupDto: UserCompleteSetupDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCompleteSetupDto' is not null or undefined
            if (userCompleteSetupDto === null || userCompleteSetupDto === undefined) {
                throw new RequiredError('userCompleteSetupDto','Required parameter userCompleteSetupDto was null or undefined when calling completeAccountSetup.');
            }
            const localVarPath = `/client/complete-account-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userCompleteSetupDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userCompleteSetupDto !== undefined ? userCompleteSetupDto : {}) : (userCompleteSetupDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pass in a receipt. If receipt is valid it will add the bought game to the user account.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverPurchases: async (body: object, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deliverPurchases.');
            }
            const localVarPath = `/client/deliverPurchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionAuthStatus: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling divisionAuthStatus.');
            }
            const localVarPath = `/client/division/{id}/auth`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrl: async (downloadDto: DownloadDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadDto' is not null or undefined
            if (downloadDto === null || downloadDto === undefined) {
                throw new RequiredError('downloadDto','Required parameter downloadDto was null or undefined when calling downloadUrl.');
            }
            const localVarPath = `/client/downloadUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof downloadDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(downloadDto !== undefined ? downloadDto : {}) : (downloadDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount: async (userEditDto: UserEditDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEditDto' is not null or undefined
            if (userEditDto === null || userEditDto === undefined) {
                throw new RequiredError('userEditDto','Required parameter userEditDto was null or undefined when calling editAccount.');
            }
            const localVarPath = `/client/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userEditDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userEditDto !== undefined ? userEditDto : {}) : (userEditDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All energyPoints from user\'s past events and completed sessions
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyPoints: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getEnergyPoints.');
            }
            const localVarPath = `/client/energyPoints/{divisionId}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get valid purchases made a single specific game for the user
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchasesForGame: async (gameId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling purchasesForGame.');
            }
            const localVarPath = `/client/purchasesForGame/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeem a coupon code, will deliver purchase to user account if coupon valid.
         * @param {RedeemCouponRequestDto} redeemCouponRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCoupon: async (redeemCouponRequestDto: RedeemCouponRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemCouponRequestDto' is not null or undefined
            if (redeemCouponRequestDto === null || redeemCouponRequestDto === undefined) {
                throw new RequiredError('redeemCouponRequestDto','Required parameter redeemCouponRequestDto was null or undefined when calling redeemCoupon.');
            }
            const localVarPath = `/client/redeemCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof redeemCouponRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(redeemCouponRequestDto !== undefined ? redeemCouponRequestDto : {}) : (redeemCouponRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnAccount: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sessionsForDivision.');
            }
            const localVarPath = `/client/division/{id}/sessions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientFile: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling uploadClientFile.');
            }
            const localVarPath = `/client/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPrivateApi - functional programming interface
 * @export
 */
export const ClientPrivateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all valid purchases of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allPurchases(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).allPurchases(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authStatus(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).authStatus(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientCreateEvent(divisionId: string, eventUpdateDto: EventUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientCreateEvent(divisionId, eventUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientLogout(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientLogout(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientParticipateEvent(eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientParticipateEvent(eventId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUnparticipateEvent(eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientUnparticipateEvent(eventId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).clientUpdateEvent(eventId, eventUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).completeAccountSetup(userCompleteSetupDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Pass in a receipt. If receipt is valid it will add the bought game to the user account.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliverPurchases(body: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).deliverPurchases(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionAuthStatus(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).divisionAuthStatus(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUrl(downloadDto: DownloadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadUrlDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).downloadUrl(downloadDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAccount(userEditDto: UserEditDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).editAccount(userEditDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All energyPoints from user\'s past events and completed sessions
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnergyPoints(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnergyPointsResponseDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).getEnergyPoints(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get valid purchases made a single specific game for the user
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchasesForGame(gameId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PurchaseEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).purchasesForGame(gameId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Redeem a coupon code, will deliver purchase to user account if coupon valid.
         * @param {RedeemCouponRequestDto} redeemCouponRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemCoupon(redeemCouponRequestDto: RedeemCouponRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).redeemCoupon(redeemCouponRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeOwnAccount(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntity>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).removeOwnAccount(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SessionEntity>>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).sessionsForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadClientFile(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadResultDto>> {
            const localVarAxiosArgs = await ClientPrivateApiAxiosParamCreator(configuration).uploadClientFile(file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientPrivateApi - factory interface
 * @export
 */
export const ClientPrivateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get all valid purchases of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allPurchases(options?: any): AxiosPromise<Array<PurchaseEntity>> {
            return ClientPrivateApiFp(configuration).allPurchases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authStatus(options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).authStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an event.
         * @param {string} divisionId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientCreateEvent(divisionId: string, eventUpdateDto: EventUpdateDto, options?: any): AxiosPromise<EventEntity> {
            return ClientPrivateApiFp(configuration).clientCreateEvent(divisionId, eventUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidates the currently used Accesstoken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout(options?: any): AxiosPromise<void> {
            return ClientPrivateApiFp(configuration).clientLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Participate in event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientParticipateEvent(eventId: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return ClientPrivateApiFp(configuration).clientParticipateEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove participation from event for current user.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUnparticipateEvent(eventId: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return ClientPrivateApiFp(configuration).clientUnparticipateEvent(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an event.
         * @param {string} eventId 
         * @param {EventUpdateDto} eventUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any): AxiosPromise<EventEntity> {
            return ClientPrivateApiFp(configuration).clientUpdateEvent(eventId, eventUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete account setup
         * @param {UserCompleteSetupDto} userCompleteSetupDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).completeAccountSetup(userCompleteSetupDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pass in a receipt. If receipt is valid it will add the bought game to the user account.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliverPurchases(body: object, options?: any): AxiosPromise<Array<PurchaseEntity>> {
            return ClientPrivateApiFp(configuration).deliverPurchases(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify authentication status and retrieve user info.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionAuthStatus(id: string, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).divisionAuthStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrl(downloadDto: DownloadDto, options?: any): AxiosPromise<DownloadUrlDto> {
            return ClientPrivateApiFp(configuration).downloadUrl(downloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user account.
         * @param {UserEditDto} userEditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(userEditDto: UserEditDto, options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).editAccount(userEditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All energyPoints from user\'s past events and completed sessions
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergyPoints(divisionId: string, options?: any): AxiosPromise<EnergyPointsResponseDto> {
            return ClientPrivateApiFp(configuration).getEnergyPoints(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get valid purchases made a single specific game for the user
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchasesForGame(gameId: string, options?: any): AxiosPromise<Array<PurchaseEntity>> {
            return ClientPrivateApiFp(configuration).purchasesForGame(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeem a coupon code, will deliver purchase to user account if coupon valid.
         * @param {RedeemCouponRequestDto} redeemCouponRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCoupon(redeemCouponRequestDto: RedeemCouponRequestDto, options?: any): AxiosPromise<PurchaseEntity> {
            return ClientPrivateApiFp(configuration).redeemCoupon(redeemCouponRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove own user account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOwnAccount(options?: any): AxiosPromise<UserEntity> {
            return ClientPrivateApiFp(configuration).removeOwnAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find sessions logged in user has for given division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsForDivision(id: string, options?: any): AxiosPromise<Array<SessionEntity>> {
            return ClientPrivateApiFp(configuration).sessionsForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file to the generic storage
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadClientFile(file: any, options?: any): AxiosPromise<FileUploadResultDto> {
            return ClientPrivateApiFp(configuration).uploadClientFile(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPrivateApi - object-oriented interface
 * @export
 * @class ClientPrivateApi
 * @extends {BaseAPI}
 */
export class ClientPrivateApi extends BaseAPI {
    /**
     * 
     * @summary Get all valid purchases of current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public allPurchases(options?: any) {
        return ClientPrivateApiFp(this.configuration).allPurchases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify authentication status and retrieve user info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public authStatus(options?: any) {
        return ClientPrivateApiFp(this.configuration).authStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an event.
     * @param {string} divisionId 
     * @param {EventUpdateDto} eventUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientCreateEvent(divisionId: string, eventUpdateDto: EventUpdateDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientCreateEvent(divisionId, eventUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidates the currently used Accesstoken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientLogout(options?: any) {
        return ClientPrivateApiFp(this.configuration).clientLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Participate in event for current user.
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientParticipateEvent(eventId: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientParticipateEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove participation from event for current user.
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientUnparticipateEvent(eventId: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientUnparticipateEvent(eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an event.
     * @param {string} eventId 
     * @param {EventUpdateDto} eventUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public clientUpdateEvent(eventId: string, eventUpdateDto: EventUpdateDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).clientUpdateEvent(eventId, eventUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete account setup
     * @param {UserCompleteSetupDto} userCompleteSetupDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public completeAccountSetup(userCompleteSetupDto: UserCompleteSetupDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).completeAccountSetup(userCompleteSetupDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pass in a receipt. If receipt is valid it will add the bought game to the user account.
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public deliverPurchases(body: object, options?: any) {
        return ClientPrivateApiFp(this.configuration).deliverPurchases(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify authentication status and retrieve user info.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public divisionAuthStatus(id: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).divisionAuthStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve download URL for given game
     * @param {DownloadDto} downloadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public downloadUrl(downloadDto: DownloadDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).downloadUrl(downloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user account.
     * @param {UserEditDto} userEditDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public editAccount(userEditDto: UserEditDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).editAccount(userEditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary All energyPoints from user\'s past events and completed sessions
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public getEnergyPoints(divisionId: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).getEnergyPoints(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get valid purchases made a single specific game for the user
     * @param {string} gameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public purchasesForGame(gameId: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).purchasesForGame(gameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redeem a coupon code, will deliver purchase to user account if coupon valid.
     * @param {RedeemCouponRequestDto} redeemCouponRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public redeemCoupon(redeemCouponRequestDto: RedeemCouponRequestDto, options?: any) {
        return ClientPrivateApiFp(this.configuration).redeemCoupon(redeemCouponRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove own user account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public removeOwnAccount(options?: any) {
        return ClientPrivateApiFp(this.configuration).removeOwnAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find sessions logged in user has for given division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public sessionsForDivision(id: string, options?: any) {
        return ClientPrivateApiFp(this.configuration).sessionsForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file to the generic storage
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPrivateApi
     */
    public uploadClientFile(file: any, options?: any) {
        return ClientPrivateApiFp(this.configuration).uploadClientFile(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ClientPublicApi - axios parameter creator
 * @export
 */
export const ClientPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousLogin: async (anonymousAccessDto: AnonymousAccessDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'anonymousAccessDto' is not null or undefined
            if (anonymousAccessDto === null || anonymousAccessDto === undefined) {
                throw new RequiredError('anonymousAccessDto','Required parameter anonymousAccessDto was null or undefined when calling anonymousLogin.');
            }
            const localVarPath = `/client/login/anonymous`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof anonymousAccessDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(anonymousAccessDto !== undefined ? anonymousAccessDto : {}) : (anonymousAccessDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin: async (appleTokenDto: AppleTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'appleTokenDto' is not null or undefined
            if (appleTokenDto === null || appleTokenDto === undefined) {
                throw new RequiredError('appleTokenDto','Required parameter appleTokenDto was null or undefined when calling appleLogin.');
            }
            const localVarPath = `/client/login/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof appleTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(appleTokenDto !== undefined ? appleTokenDto : {}) : (appleTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling articlesOfDivision.');
            }
            const localVarPath = `/client/division/{id}/articles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return published cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/city`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling contactForDivision.');
            }
            const localVarPath = `/client/division/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnArticle: async (articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new RequiredError('articleId','Required parameter articleId was null or undefined when calling createHitOnArticle.');
            }
            // verify required parameter 'articleAnalyticsDto' is not null or undefined
            if (articleAnalyticsDto === null || articleAnalyticsDto === undefined) {
                throw new RequiredError('articleAnalyticsDto','Required parameter articleAnalyticsDto was null or undefined when calling createHitOnArticle.');
            }
            const localVarPath = `/client/articleAnalytics/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof articleAnalyticsDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(articleAnalyticsDto !== undefined ? articleAnalyticsDto : {}) : (articleAnalyticsDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return division with given access code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionByAccessCode: async (code: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling divisionByAccessCode.');
            }
            const localVarPath = `/client/division/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrlPublic: async (downloadDto: DownloadDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'downloadDto' is not null or undefined
            if (downloadDto === null || downloadDto === undefined) {
                throw new RequiredError('downloadDto','Required parameter downloadDto was null or undefined when calling downloadUrlPublic.');
            }
            const localVarPath = `/client/downloadUrlPublic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof downloadDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(downloadDto !== undefined ? downloadDto : {}) : (downloadDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsForDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling eventsForDivision.');
            }
            const localVarPath = `/client/division/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin: async (facebookTokenDto: FacebookTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'facebookTokenDto' is not null or undefined
            if (facebookTokenDto === null || facebookTokenDto === undefined) {
                throw new RequiredError('facebookTokenDto','Required parameter facebookTokenDto was null or undefined when calling facebookLogin.');
            }
            const localVarPath = `/client/login/facebook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof facebookTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(facebookTokenDto !== undefined ? facebookTokenDto : {}) : (facebookTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find games for city
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfCity: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gamesOfCity.');
            }
            const localVarPath = `/client/city/{id}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfDivision: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling gamesOfDivision.');
            }
            const localVarPath = `/client/division/{id}/games`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQRCode: async (divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getDivisionQRCode.');
            }
            const localVarPath = `/client/division/{divisionId}/qr`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatedLocation: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/estimatedLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} divisionId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventInDivision: async (divisionId: string, eventId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling getEventInDivision.');
            }
            // verify required parameter 'eventId' is not null or undefined
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId','Required parameter eventId was null or undefined when calling getEventInDivision.');
            }
            const localVarPath = `/client/division/{divisionId}/events/{eventId}`
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscores: async (gameId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getHighscores.');
            }
            const localVarPath = `/client/highscores/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscoresWithSession: async (gameId: string, sessionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getHighscoresWithSession.');
            }
            // verify required parameter 'sessionId' is not null or undefined
            if (sessionId === null || sessionId === undefined) {
                throw new RequiredError('sessionId','Required parameter sessionId was null or undefined when calling getHighscoresWithSession.');
            }
            const localVarPath = `/client/highscores/{gameId}/{sessionId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinedHighscoresWithKey: async (gameId: string, userKey: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getJoinedHighscoresWithKey.');
            }
            // verify required parameter 'userKey' is not null or undefined
            if (userKey === null || userKey === undefined) {
                throw new RequiredError('userKey','Required parameter userKey was null or undefined when calling getJoinedHighscoresWithKey.');
            }
            const localVarPath = `/client/highscores/joined/{gameId}/{userKey}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
                .replace(`{${"userKey"}}`, encodeURIComponent(String(userKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPageContent: async (languageId: string, pageId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageId' is not null or undefined
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId','Required parameter languageId was null or undefined when calling getPublicPageContent.');
            }
            // verify required parameter 'pageId' is not null or undefined
            if (pageId === null || pageId === undefined) {
                throw new RequiredError('pageId','Required parameter pageId was null or undefined when calling getPublicPageContent.');
            }
            const localVarPath = `/client/page/{languageId}/{pageId}`
                .replace(`{${"languageId"}}`, encodeURIComponent(String(languageId)))
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reviews for game id
         * @param {string} gameId 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews: async (gameId: string, take: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getReviews.');
            }
            // verify required parameter 'take' is not null or undefined
            if (take === null || take === undefined) {
                throw new RequiredError('take','Required parameter take was null or undefined when calling getReviews.');
            }
            const localVarPath = `/client/reviews/{gameId}`
                .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (googleTokenDto: GoogleTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleTokenDto' is not null or undefined
            if (googleTokenDto === null || googleTokenDto === undefined) {
                throw new RequiredError('googleTokenDto','Required parameter googleTokenDto was null or undefined when calling googleLogin.');
            }
            const localVarPath = `/client/login/google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof googleTokenDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(googleTokenDto !== undefined ? googleTokenDto : {}) : (googleTokenDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return division with specific id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDivisionById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling loadDivisionById.');
            }
            const localVarPath = `/client/division/refresh/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participantsForEvent: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling participantsForEvent.');
            }
            const localVarPath = `/client/events/{id}/participants`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessLogin: async (passwordlessRequestDto: PasswordlessRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordlessRequestDto' is not null or undefined
            if (passwordlessRequestDto === null || passwordlessRequestDto === undefined) {
                throw new RequiredError('passwordlessRequestDto','Required parameter passwordlessRequestDto was null or undefined when calling passwordlessLogin.');
            }
            const localVarPath = `/client/login/passwordless`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordlessRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordlessRequestDto !== undefined ? passwordlessRequestDto : {}) : (passwordlessRequestDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessVerify: async (passwordlessVerifyDto: PasswordlessVerifyDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordlessVerifyDto' is not null or undefined
            if (passwordlessVerifyDto === null || passwordlessVerifyDto === undefined) {
                throw new RequiredError('passwordlessVerifyDto','Required parameter passwordlessVerifyDto was null or undefined when calling passwordlessVerify.');
            }
            const localVarPath = `/client/login/passwordless/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordlessVerifyDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordlessVerifyDto !== undefined ? passwordlessVerifyDto : {}) : (passwordlessVerifyDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeeback: async (sceneId: string, feedbackPostDto: FeedbackPostDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sceneId' is not null or undefined
            if (sceneId === null || sceneId === undefined) {
                throw new RequiredError('sceneId','Required parameter sceneId was null or undefined when calling postFeeback.');
            }
            // verify required parameter 'feedbackPostDto' is not null or undefined
            if (feedbackPostDto === null || feedbackPostDto === undefined) {
                throw new RequiredError('feedbackPostDto','Required parameter feedbackPostDto was null or undefined when calling postFeeback.');
            }
            const localVarPath = `/client/feedback/{sceneId}`
                .replace(`{${"sceneId"}}`, encodeURIComponent(String(sceneId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof feedbackPostDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(feedbackPostDto !== undefined ? feedbackPostDto : {}) : (feedbackPostDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession: async (sessionUpdateDto: SessionUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionUpdateDto' is not null or undefined
            if (sessionUpdateDto === null || sessionUpdateDto === undefined) {
                throw new RequiredError('sessionUpdateDto','Required parameter sessionUpdateDto was null or undefined when calling updateSession.');
            }
            const localVarPath = `/client/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof sessionUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(sessionUpdateDto !== undefined ? sessionUpdateDto : {}) : (sessionUpdateDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientPublicApi - functional programming interface
 * @export
 */
export const ClientPublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).anonymousLogin(anonymousAccessDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleLogin(appleTokenDto: AppleTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).appleLogin(appleTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articlesOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ArticleEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).articlesOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return published cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cities(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DivisionEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).cities(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionContactDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).contactForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleOkResponse>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).createHitOnArticle(articleId, articleAnalyticsDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return division with given access code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async divisionByAccessCode(code: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).divisionByAccessCode(code, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadUrlPublic(downloadDto: DownloadDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadUrlDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).downloadUrlPublic(downloadDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsForDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).eventsForDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).facebookLogin(facebookTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find games for city
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesOfCity(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).gamesOfCity(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gamesOfDivision(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GameEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).gamesOfDivision(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDivisionQRCode(divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getDivisionQRCode(divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEstimatedLocation(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EstimatedLocationDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getEstimatedLocation(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} divisionId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventInDivision(divisionId: string, eventId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getEventInDivision(divisionId, eventId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighscores(gameId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getHighscores(gameId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighscoresWithSession(gameId: string, sessionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getHighscoresWithSession(gameId, sessionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJoinedHighscoresWithKey(gameId: string, userKey: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HighscoreDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getJoinedHighscoresWithKey(gameId, userKey, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicPageContent(languageId: string, pageId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageContentEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getPublicPageContent(languageId, pageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get reviews for game id
         * @param {string} gameId 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviews(gameId: string, take: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReviewDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getReviews(gameId, take, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslations(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LanguageTranslationsDto>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).getTranslations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(googleTokenDto: GoogleTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessToken>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).googleLogin(googleTokenDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Return division with specific id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDivisionById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DivisionEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).loadDivisionById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async participantsForEvent(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventParticipantEntity>>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).participantsForEvent(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordlessRequestResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).passwordlessLogin(passwordlessRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PasswordlessVerifyResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).passwordlessVerify(passwordlessVerifyDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedbackEntity>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).postFeeback(sceneId, feedbackPostDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSession(sessionUpdateDto: SessionUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await ClientPublicApiAxiosParamCreator(configuration).updateSession(sessionUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientPublicApi - factory interface
 * @export
 */
export const ClientPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Log in anonymously
         * @param {AnonymousAccessDto} anonymousAccessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).anonymousLogin(anonymousAccessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with apple token
         * @param {AppleTokenDto} appleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleLogin(appleTokenDto: AppleTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).appleLogin(appleTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find articles for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articlesOfDivision(id: string, options?: any): AxiosPromise<Array<ArticleEntity>> {
            return ClientPublicApiFp(configuration).articlesOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return published cities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cities(options?: any): AxiosPromise<Array<DivisionEntity>> {
            return ClientPublicApiFp(configuration).cities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the contact information for the division.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactForDivision(id: string, options?: any): AxiosPromise<DivisionContactDto> {
            return ClientPublicApiFp(configuration).contactForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create analytics based on the time user spends on article
         * @param {string} articleId 
         * @param {ArticleAnalyticsDto} articleAnalyticsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any): AxiosPromise<SimpleOkResponse> {
            return ClientPublicApiFp(configuration).createHitOnArticle(articleId, articleAnalyticsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return division with given access code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        divisionByAccessCode(code: string, options?: any): AxiosPromise<DivisionEntity> {
            return ClientPublicApiFp(configuration).divisionByAccessCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve download URL for given game
         * @param {DownloadDto} downloadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUrlPublic(downloadDto: DownloadDto, options?: any): AxiosPromise<DownloadUrlDto> {
            return ClientPublicApiFp(configuration).downloadUrlPublic(downloadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsForDivision(id: string, options?: any): AxiosPromise<Array<EventEntity>> {
            return ClientPublicApiFp(configuration).eventsForDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with facebook token
         * @param {FacebookTokenDto} facebookTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).facebookLogin(facebookTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find games for city
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfCity(id: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return ClientPublicApiFp(configuration).gamesOfCity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Find games for division
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gamesOfDivision(id: string, options?: any): AxiosPromise<Array<GameEntity>> {
            return ClientPublicApiFp(configuration).gamesOfDivision(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get division QR Code
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDivisionQRCode(divisionId: string, options?: any): AxiosPromise<QrDto> {
            return ClientPublicApiFp(configuration).getDivisionQRCode(divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve estimated lat/lon location for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEstimatedLocation(options?: any): AxiosPromise<EstimatedLocationDto> {
            return ClientPublicApiFp(configuration).getEstimatedLocation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get events for division
         * @param {string} divisionId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventInDivision(divisionId: string, eventId: string, options?: any): AxiosPromise<EventEntity> {
            return ClientPublicApiFp(configuration).getEventInDivision(divisionId, eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscores(gameId: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getHighscores(gameId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} gameId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighscoresWithSession(gameId: string, sessionId: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getHighscoresWithSession(gameId, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get joined project-wide highscores based on user key.
         * @param {string} gameId 
         * @param {string} userKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinedHighscoresWithKey(gameId: string, userKey: string, options?: any): AxiosPromise<Array<HighscoreDto>> {
            return ClientPublicApiFp(configuration).getJoinedHighscoresWithKey(gameId, userKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a page for active Whitelabel using the X-App-Bundle-ID request header.
         * @param {string} languageId 
         * @param {string} pageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicPageContent(languageId: string, pageId: string, options?: any): AxiosPromise<PageContentEntity> {
            return ClientPublicApiFp(configuration).getPublicPageContent(languageId, pageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reviews for game id
         * @param {string} gameId 
         * @param {number} take 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviews(gameId: string, take: number, options?: any): AxiosPromise<Array<ReviewDto>> {
            return ClientPublicApiFp(configuration).getReviews(gameId, take, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all up to date translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations(options?: any): AxiosPromise<Array<LanguageTranslationsDto>> {
            return ClientPublicApiFp(configuration).getTranslations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log into client with google token
         * @param {GoogleTokenDto} googleTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(googleTokenDto: GoogleTokenDto, options?: any): AxiosPromise<AccessToken> {
            return ClientPublicApiFp(configuration).googleLogin(googleTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return division with specific id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDivisionById(id: string, options?: any): AxiosPromise<DivisionEntity> {
            return ClientPublicApiFp(configuration).loadDivisionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get participants for event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        participantsForEvent(id: string, options?: any): AxiosPromise<Array<EventParticipantEntity>> {
            return ClientPublicApiFp(configuration).participantsForEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a verification token via passwordless login
         * @param {PasswordlessRequestDto} passwordlessRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any): AxiosPromise<PasswordlessRequestResultDto> {
            return ClientPublicApiFp(configuration).passwordlessLogin(passwordlessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a token against an earlier generated verification token
         * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any): AxiosPromise<PasswordlessVerifyResultDto> {
            return ClientPublicApiFp(configuration).passwordlessVerify(passwordlessVerifyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post feedback for a given scene ID.
         * @param {string} sceneId 
         * @param {FeedbackPostDto} feedbackPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any): AxiosPromise<FeedbackEntity> {
            return ClientPublicApiFp(configuration).postFeeback(sceneId, feedbackPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update session data for game session. ID\'s are client generated.
         * @param {SessionUpdateDto} sessionUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSession(sessionUpdateDto: SessionUpdateDto, options?: any): AxiosPromise<ResultDto> {
            return ClientPublicApiFp(configuration).updateSession(sessionUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientPublicApi - object-oriented interface
 * @export
 * @class ClientPublicApi
 * @extends {BaseAPI}
 */
export class ClientPublicApi extends BaseAPI {
    /**
     * 
     * @summary Log in anonymously
     * @param {AnonymousAccessDto} anonymousAccessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public anonymousLogin(anonymousAccessDto: AnonymousAccessDto, options?: any) {
        return ClientPublicApiFp(this.configuration).anonymousLogin(anonymousAccessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with apple token
     * @param {AppleTokenDto} appleTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public appleLogin(appleTokenDto: AppleTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).appleLogin(appleTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find articles for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public articlesOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).articlesOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return published cities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public cities(options?: any) {
        return ClientPublicApiFp(this.configuration).cities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the contact information for the division.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public contactForDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).contactForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create analytics based on the time user spends on article
     * @param {string} articleId 
     * @param {ArticleAnalyticsDto} articleAnalyticsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public createHitOnArticle(articleId: string, articleAnalyticsDto: ArticleAnalyticsDto, options?: any) {
        return ClientPublicApiFp(this.configuration).createHitOnArticle(articleId, articleAnalyticsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return division with given access code
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public divisionByAccessCode(code: string, options?: any) {
        return ClientPublicApiFp(this.configuration).divisionByAccessCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve download URL for given game
     * @param {DownloadDto} downloadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public downloadUrlPublic(downloadDto: DownloadDto, options?: any) {
        return ClientPublicApiFp(this.configuration).downloadUrlPublic(downloadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public eventsForDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).eventsForDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with facebook token
     * @param {FacebookTokenDto} facebookTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public facebookLogin(facebookTokenDto: FacebookTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).facebookLogin(facebookTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find games for city
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public gamesOfCity(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).gamesOfCity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Find games for division
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public gamesOfDivision(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).gamesOfDivision(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get division QR Code
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getDivisionQRCode(divisionId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getDivisionQRCode(divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve estimated lat/lon location for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getEstimatedLocation(options?: any) {
        return ClientPublicApiFp(this.configuration).getEstimatedLocation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get events for division
     * @param {string} divisionId 
     * @param {string} eventId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getEventInDivision(divisionId: string, eventId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getEventInDivision(divisionId, eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post feedback for a given scene ID.
     * @param {string} gameId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getHighscores(gameId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getHighscores(gameId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post feedback for a given scene ID.
     * @param {string} gameId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getHighscoresWithSession(gameId: string, sessionId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getHighscoresWithSession(gameId, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get joined project-wide highscores based on user key.
     * @param {string} gameId 
     * @param {string} userKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getJoinedHighscoresWithKey(gameId: string, userKey: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getJoinedHighscoresWithKey(gameId, userKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a page for active Whitelabel using the X-App-Bundle-ID request header.
     * @param {string} languageId 
     * @param {string} pageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getPublicPageContent(languageId: string, pageId: string, options?: any) {
        return ClientPublicApiFp(this.configuration).getPublicPageContent(languageId, pageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reviews for game id
     * @param {string} gameId 
     * @param {number} take 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getReviews(gameId: string, take: number, options?: any) {
        return ClientPublicApiFp(this.configuration).getReviews(gameId, take, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all up to date translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public getTranslations(options?: any) {
        return ClientPublicApiFp(this.configuration).getTranslations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log into client with google token
     * @param {GoogleTokenDto} googleTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public googleLogin(googleTokenDto: GoogleTokenDto, options?: any) {
        return ClientPublicApiFp(this.configuration).googleLogin(googleTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return division with specific id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public loadDivisionById(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).loadDivisionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get participants for event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public participantsForEvent(id: string, options?: any) {
        return ClientPublicApiFp(this.configuration).participantsForEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a verification token via passwordless login
     * @param {PasswordlessRequestDto} passwordlessRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public passwordlessLogin(passwordlessRequestDto: PasswordlessRequestDto, options?: any) {
        return ClientPublicApiFp(this.configuration).passwordlessLogin(passwordlessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a token against an earlier generated verification token
     * @param {PasswordlessVerifyDto} passwordlessVerifyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public passwordlessVerify(passwordlessVerifyDto: PasswordlessVerifyDto, options?: any) {
        return ClientPublicApiFp(this.configuration).passwordlessVerify(passwordlessVerifyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post feedback for a given scene ID.
     * @param {string} sceneId 
     * @param {FeedbackPostDto} feedbackPostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public postFeeback(sceneId: string, feedbackPostDto: FeedbackPostDto, options?: any) {
        return ClientPublicApiFp(this.configuration).postFeeback(sceneId, feedbackPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update session data for game session. ID\'s are client generated.
     * @param {SessionUpdateDto} sessionUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientPublicApi
     */
    public updateSession(sessionUpdateDto: SessionUpdateDto, options?: any) {
        return ClientPublicApiFp(this.configuration).updateSession(sessionUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeepLinkApi - axios parameter creator
 * @export
 */
export const DeepLinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLink: async (deepLinkFindDto: DeepLinkFindDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deepLinkFindDto' is not null or undefined
            if (deepLinkFindDto === null || deepLinkFindDto === undefined) {
                throw new RequiredError('deepLinkFindDto','Required parameter deepLinkFindDto was null or undefined when calling retrieveDeepLink.');
            }
            const localVarPath = `/deep-link/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deepLinkFindDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deepLinkFindDto !== undefined ? deepLinkFindDto : {}) : (deepLinkFindDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDeepLink: async (deepLinkPutDto: DeepLinkPutDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deepLinkPutDto' is not null or undefined
            if (deepLinkPutDto === null || deepLinkPutDto === undefined) {
                throw new RequiredError('deepLinkPutDto','Required parameter deepLinkPutDto was null or undefined when calling saveDeepLink.');
            }
            const localVarPath = `/deep-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof deepLinkPutDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(deepLinkPutDto !== undefined ? deepLinkPutDto : {}) : (deepLinkPutDto || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeepLinkApi - functional programming interface
 * @export
 */
export const DeepLinkApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeepLinkResponseDto>> {
            const localVarAxiosArgs = await DeepLinkApiAxiosParamCreator(configuration).retrieveDeepLink(deepLinkFindDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await DeepLinkApiAxiosParamCreator(configuration).saveDeepLink(deepLinkPutDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeepLinkApi - factory interface
 * @export
 */
export const DeepLinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get deep link for request
         * @param {DeepLinkFindDto} deepLinkFindDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any): AxiosPromise<DeepLinkResponseDto> {
            return DeepLinkApiFp(configuration).retrieveDeepLink(deepLinkFindDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save deep link for device
         * @param {DeepLinkPutDto} deepLinkPutDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any): AxiosPromise<string> {
            return DeepLinkApiFp(configuration).saveDeepLink(deepLinkPutDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeepLinkApi - object-oriented interface
 * @export
 * @class DeepLinkApi
 * @extends {BaseAPI}
 */
export class DeepLinkApi extends BaseAPI {
    /**
     * 
     * @summary Get deep link for request
     * @param {DeepLinkFindDto} deepLinkFindDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeepLinkApi
     */
    public retrieveDeepLink(deepLinkFindDto: DeepLinkFindDto, options?: any) {
        return DeepLinkApiFp(this.configuration).retrieveDeepLink(deepLinkFindDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save deep link for device
     * @param {DeepLinkPutDto} deepLinkPutDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeepLinkApi
     */
    public saveDeepLink(deepLinkPutDto: DeepLinkPutDto, options?: any) {
        return DeepLinkApiFp(this.configuration).saveDeepLink(deepLinkPutDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HotlinkApi - axios parameter creator
 * @export
 */
export const HotlinkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGamePreview: async (gameId: string, scenarioId?: string, sceneId?: string, language?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            if (gameId === null || gameId === undefined) {
                throw new RequiredError('gameId','Required parameter gameId was null or undefined when calling getGamePreview.');
            }
            const localVarPath = `/hotlink/game`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gameId !== undefined) {
                localVarQueryParameter['gameId'] = gameId;
            }

            if (scenarioId !== undefined) {
                localVarQueryParameter['scenarioId'] = scenarioId;
            }

            if (sceneId !== undefined) {
                localVarQueryParameter['sceneId'] = sceneId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HotlinkApi - functional programming interface
 * @export
 */
export const HotlinkApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGamePreview(gameId: string, scenarioId?: string, sceneId?: string, language?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HotlinkDeployEventDto>> {
            const localVarAxiosArgs = await HotlinkApiAxiosParamCreator(configuration).getGamePreview(gameId, scenarioId, sceneId, language, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HotlinkApi - factory interface
 * @export
 */
export const HotlinkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Get game data for hotlink preview
         * @param {string} gameId Game ID
         * @param {string} [scenarioId] Optional base scenario ID
         * @param {string} [sceneId] Optional Scene ID
         * @param {string} [language] Optional language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGamePreview(gameId: string, scenarioId?: string, sceneId?: string, language?: string, options?: any): AxiosPromise<HotlinkDeployEventDto> {
            return HotlinkApiFp(configuration).getGamePreview(gameId, scenarioId, sceneId, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HotlinkApi - object-oriented interface
 * @export
 * @class HotlinkApi
 * @extends {BaseAPI}
 */
export class HotlinkApi extends BaseAPI {
    /**
     * 
     * @summary Get game data for hotlink preview
     * @param {string} gameId Game ID
     * @param {string} [scenarioId] Optional base scenario ID
     * @param {string} [sceneId] Optional Scene ID
     * @param {string} [language] Optional language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HotlinkApi
     */
    public getGamePreview(gameId: string, scenarioId?: string, sceneId?: string, language?: string, options?: any) {
        return HotlinkApiFp(this.configuration).getGamePreview(gameId, scenarioId, sceneId, language, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * QRCodeApi - axios parameter creator
 * @export
 */
export const QRCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfQrCodeValid: async (id: string, divisionId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling checkIfQrCodeValid.');
            }
            // verify required parameter 'divisionId' is not null or undefined
            if (divisionId === null || divisionId === undefined) {
                throw new RequiredError('divisionId','Required parameter divisionId was null or undefined when calling checkIfQrCodeValid.');
            }
            const localVarPath = `/qr/valid/{id}/{divisionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"divisionId"}}`, encodeURIComponent(String(divisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestQRCodeData: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling requestQRCodeData.');
            }
            const localVarPath = `/qr/{id}/request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get redirect url for QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRedirectUri: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling requestRedirectUri.');
            }
            const localVarPath = `/qr/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QRCodeApi - functional programming interface
 * @export
 */
export const QRCodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfQrCodeValid(id: string, divisionId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).checkIfQrCodeValid(id, divisionId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestQRCodeData(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrRedirectDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).requestQRCodeData(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get redirect url for QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestRedirectUri(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QrRedirectDto>> {
            const localVarAxiosArgs = await QRCodeApiAxiosParamCreator(configuration).requestRedirectUri(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * QRCodeApi - factory interface
 * @export
 */
export const QRCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check if given QR Code is valid.
         * @param {string} id 
         * @param {string} divisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfQrCodeValid(id: string, divisionId: string, options?: any): AxiosPromise<void> {
            return QRCodeApiFp(configuration).checkIfQrCodeValid(id, divisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request QR Code data and register a hit for it.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestQRCodeData(id: string, options?: any): AxiosPromise<QrRedirectDto> {
            return QRCodeApiFp(configuration).requestQRCodeData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get redirect url for QR Code
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestRedirectUri(id: string, options?: any): AxiosPromise<QrRedirectDto> {
            return QRCodeApiFp(configuration).requestRedirectUri(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QRCodeApi - object-oriented interface
 * @export
 * @class QRCodeApi
 * @extends {BaseAPI}
 */
export class QRCodeApi extends BaseAPI {
    /**
     * 
     * @summary Check if given QR Code is valid.
     * @param {string} id 
     * @param {string} divisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public checkIfQrCodeValid(id: string, divisionId: string, options?: any) {
        return QRCodeApiFp(this.configuration).checkIfQrCodeValid(id, divisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request QR Code data and register a hit for it.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public requestQRCodeData(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).requestQRCodeData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get redirect url for QR Code
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QRCodeApi
     */
    public requestRedirectUri(id: string, options?: any) {
        return QRCodeApiFp(this.configuration).requestRedirectUri(id, options).then((request) => request(this.axios, this.basePath));
    }
}


